import { Plus } from "lucide-react";
import { Button } from "@/shared/ui/button";

interface UserPanelHeaderProps {
  usersCount?: number;
  onAddUserClick: () => void;
}

export function UserPanelHeader({
  usersCount,
  onAddUserClick,
}: UserPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-semibold text-ink-900">
          Users {usersCount !== undefined && `(${usersCount})`}
        </h2>
        <p className="mt-1 text-sm text-ink-600 max-w-3xl">
          Review active users and their access levels.
        </p>
      </div>
      <Button onClick={onAddUserClick} className="gap-2">
        <Plus className="h-4 w-4" />
        Add new user
      </Button>
    </div>
  );
}
